// Api End Point
export const URL = 'crop/'

// Model Properties
export const PROP_ID = 'id'
export const PROP_CROP_ID = PROP_ID
export const PROP_ABBREVIATION = 'abbreviation'
export const PROP_BIO_LIMIT_BU_AC = 'bio_limit_bu_ac'
export const PROP_DSSAT_CROP_CODE = 'dssat_crop_code'
export const PROP_GROUP = 'group'
export const PROP_LBS_PER_BU = 'lbs_per_bu'
export const PROP_NAME = 'name'
export const PROP_NITR_MANAGED = 'nitr_managed'
export const PROP_RECOMMENDATIONENGINEID = 'recommendationEngineId'
export const PROP_STANDARD_MOISTURE = 'standard_moisture'
export const PROP_HEFTY_YIELD_UNIT = 'heftyYieldUnit'
export const PROP_HEFTY_REC_SUPPORT = 'heftyRecSupport'

// Yield Units
export const BUSHELS = 'Bushels'
export const TONS = 'Tons'
export const KGS = 'Kgs'

// Crop names
export const COTTON = 'cotton'

// State Configuration
export const MODEL = 'Crops'
export const TREE = 'cropData'
export const BRANCH = 'crops'
